module.exports = function() {
  return new Worker(__webpack_public_path__ + "efb4759542536547970c.worker.js");
};